// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"249aacbc","985":"648ead07"}[chunkId] + ".chunk.js";
};